// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QUqM","buttons":"styles_buttons__EAi1L"};